import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
  UseQueryResult
} from 'react-query';

const MINUTE_IN_MILLISECOND = 1000 * 60;

function useQueryWrapperP1<
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey
>(
  queryKey: TQueryKey,
  queryFn: QueryFunction<TQueryFnData, TQueryKey>,
  otherOptions?: Omit<
    UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
    'queryKey' | 'queryFn'
  >
): UseQueryResult<TData, TError> {
  return useQuery<TQueryFnData, TError, TData, TQueryKey>(queryKey, queryFn, {
    staleTime: 2 * MINUTE_IN_MILLISECOND,
    refetchOnWindowFocus: true,
    cacheTime: 5 * MINUTE_IN_MILLISECOND,
    ...otherOptions
  });
}

export default useQueryWrapperP1;
